var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddConnectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.2912 15.2438L5.93451 17.6005C4.95747 18.5776 3.37523 18.5776 2.39902 17.6007C1.42261 16.6243 1.42261 15.0419 2.39882 14.0657L7.11303 9.3515C8.08925 8.37524 9.67164 8.37524 10.6479 9.3515C10.9733 9.67693 11.5009 9.67693 11.8264 9.3515C12.1518 9.02607 12.1518 8.49841 11.8264 8.17298C10.1993 6.54586 7.56163 6.54586 5.93451 8.17298L1.22034 12.8871C-0.40678 14.5143 -0.40678 17.1519 1.22034 18.779C2.84726 20.407 5.48509 20.407 7.11307 18.779L9.46976 16.4223C9.79519 16.0969 9.79519 15.5692 9.46976 15.2438C9.14433 14.9184 8.61663 14.9184 8.2912 15.2438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.78 1.22034C17.1528 -0.40678 14.5143 -0.40678 12.8872 1.22034L10.0597 4.04786C9.73428 4.37329 9.73428 4.90095 10.0597 5.22638C10.3851 5.55181 10.9128 5.55181 11.2382 5.22638L14.0658 2.39886C15.042 1.42261 16.6252 1.42261 17.6014 2.39886C18.5777 3.37508 18.5777 4.95747 17.6014 5.93369L12.4164 11.1188C11.4402 12.095 9.8578 12.095 8.88158 11.1188C8.55615 10.7933 8.02849 10.7933 7.70306 11.1188C7.37763 11.4442 7.37763 11.9718 7.70306 12.2973C9.33018 13.9244 11.9678 13.9244 13.5949 12.2973L18.78 7.11225C20.4071 5.48513 20.4071 2.84746 18.78 1.22034Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddConnectionIcon);
export default __webpack_public_path__ + "static/media/addConnectionIcon.f86c480c361aa8579df4dc2a44ecd9a6.svg";
export { ForwardRef as ReactComponent };